<template>
  <div class="mail__mail-item sm:px-4 px-2 py-6" :class="{'mail__opened-mail': mail.isRead}">
    <!-- MAIL ROW 1 : META -->
    <div class="flex w-full">
      <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" src="../../../img/avatar.png" size="40px"/>
      <div class="flex w-full justify-between items-start">
        <div class="mail__details">
          <h5 class="mb-1" :class="{'font-semibold': !mail.isRead}">{{ sentFolderId !== filter ? mail.sender.emailAddress.name : mail.toRecipients[0].emailAddress.name }}</h5>
          <span v-if="mail.subject">{{ mail.subject }}</span>
          <span v-else>(no subject)</span>
        </div>

        <div class="mail-item__meta flex items-center">
          <span>{{ mail.receivedDateTime | formatDateTime }}</span>
        </div>
      </div>
    </div>
    <!-- /MAIL ROW 1 -->

    <!-- MAIL ROW 2 : MSG & ACTIONS -->
    <div class="flex w-full">
      <div class="mail__message truncate ml-3">
        <span>{{ mail.body.content | filter_tags }}</span>
      </div>
    </div>
    <!-- /MAIL ROW 2 -->
  </div>
</template>

<script>
import FeatherIcon from "./components/FeatherIcon";

export default {
  props: {
    mail: {type: Object, required: true},
    isSelected: {type: Boolean, required: true},
    filter: {type: String},
    sentFolderId: {type: String}
  },
  components: {FeatherIcon},
  data() {
    return {
      isSelectedMail: this.isSelected
    }
  },
  watch: {
    isSelected(value) {
      this.isSelectedMail = value
    },
    isSelectedMail(val) {
      val ? this.$emit('addToSelected', this.mail.id) : this.$emit('removeSelected', this.mail.id)
    }
  }
}
</script>

